import * as React from "react";
import { MARKETPLACE_SERVICE_URL } from "../../../envVariables";

interface Props {
  templateName: string;
  hasIcon?: boolean;
  className?: string;
}

export const MarketplaceIcon: React.FC<Props> = ({ templateName, hasIcon, className }) => {
  const imgRef = React.useRef<HTMLImageElement>(null);

  if (hasIcon === false) {
    return null;
  }

  return (
    <img
      ref={imgRef}
      className={className}
      src={`${MARKETPLACE_SERVICE_URL}/icon/${templateName}`}
      onError={() => {
        if (imgRef.current) {
          imgRef.current.style.display = "none";
        }
      }}
    />
  );
};
